//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global angular: false */

(function() {
  const curalate = angular.module('curalate');

  curalate.service('NotesApiService', [
    '$http',
    'PromiseService',
    'RestBaseUrl',
    function(
            $http,
            PromiseService,
            RestBaseUrl,
        ) {
      this.getNotesAsync = function(itemId) {
        return PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/universal-image-actions/items/${itemId}/notes`));
      };

      this.addNoteAsync = function(itemId, text, mentionedUsers) {
        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/universal-image-actions/items/${itemId}/notes`, {
          text,
          notifiedUsers: mentionedUsers,
        }));
      };

      this.getSubscriptionsAsync = function(itemId) {
        return PromiseService.processHttpResponse($http.get(`${RestBaseUrl}/universal-image-actions/items/${itemId}/notes-subscriptions`));
      };

      this.updateUserSubscriptionAsync = function(itemId, params) {
        return PromiseService.processHttpResponse($http.post(`${RestBaseUrl}/universal-image-actions/items/${itemId}/notes-subscriptions`, params));
      };
    },
  ]);
})();
